import React from 'react'
import { Box, Divider, Typography } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"
import { dsColorNew } from "@palette"


export default function conditionNameColumn() {

	const iconMap = {
		"More expensive": "chart-line-up",
		"Cheaper": "chart-line-down",
		"Cheaper/More expensive": "chart-line-up-down",
		"$": "money-bills",
		"%": "percent"
	}
	const colorMap = {
		"More expensive": dsColorNew.successText,
		"Cheaper": dsColorNew.dangerRed,
		"Cheaper/More expensive": dsColorNew.noteAmber,
		"$": dsColorNew.successText,
		"%": dsColorNew.black
	}

	return {
		name: 'conditionName',
		label: 'Condition',
		options: {
			filter: false,
			customBodyRowRenderLite:
				(value, { comparatorName, comparatorValue, comparatorUnitName }) => <Box sx={{
					display: "flex",
					alignItems: 'center',
					justifyContent: "center",
					flexDirection: "column"
				}}>
					<Typography sx={{ fontWeight: "bold" }}>{value}</Typography>
					<Divider sx={{ my: 1, width: "80%", borderColor: dsColorNew.grayBorder }}/>
					<Box sx={{ display: "flex", alignItems: 'center', justifyContent: "center" }}>
						<Typography sx={{ fontWeight: "bold" }}>{comparatorValue}</Typography>
						<IconSeeker icon={iconMap[comparatorUnitName]}
									sx={{ mx: .7, fontSize: 14, color: colorMap[comparatorUnitName] }}/>
						<IconSeeker
							tooltip={comparatorName}
							icon={iconMap[comparatorName]}
							sx={{ fontSize: 14, color: colorMap[comparatorName] }}
						/>
					</Box>
				</Box>
		}
	}
}